<script setup lang="ts">
  import { useLocale } from '@tundr/i18n';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import { computed, useId } from 'vue';
  import { FontIcon } from '../FontIcon';
  import { Tooltip } from '../Tooltip';
  import {
    triggerClass as baseTriggerClass,
    withContentClass,
  } from './InfoTooltip.css';
  import type { InfoTooltipProps } from './InfoTooltip.types';

  const props = withDefaults(defineProps<InfoTooltipProps>(), {
    iconName: TUNDR_ICONS.INFO,
    showTooltip: true,
  });

  const { t } = useLocale('ds-components');

  const uid = useId();

  const triggerClasses = computed(() => [baseTriggerClass, props.triggerClass]);

  const resolvedTestId = computed(
    () => props.testId ?? `ds-info-tooltip-${uid}`,
  );

  const resolvedAriaLabel = computed(
    () => props.ariaLabel ?? t('info_tooltip.aria_label'),
  );
</script>

<template>
  <span v-if="$slots.default || showTooltip" :class="withContentClass">
    <slot />
    <Tooltip
      v-if="showTooltip"
      :id="id"
      :title="title"
      :description="description"
      :position="position"
      :size="size"
      :offset="offset"
    >
      <button
        type="button"
        :class="triggerClasses"
        :aria-label="resolvedAriaLabel"
        :data-testid="resolvedTestId"
        @click.stop
      >
        <FontIcon :icon-name="iconName" />
      </button>
    </Tooltip>
  </span>
</template>
